// Adapted from https://github.com/fknussel/react-router-ga/blob/master/index.js
/* LICENSE:
MIT License

Copyright (c) 2017 Federico Knüssel

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

import * as React from "react";
import { withRouter } from "react-router-dom";

/*type Props = {
  id: string, // Google Analytics Tracking ID
  basename: string,
  debug: boolean,
  trackPathnameOnly: boolean,
  children?: React.Node,
  location: Location,
  history: RouterHistory
};*/

class ReactRouterGA extends React.Component {
  constructor(props) {
    super(props);

    this.sendPageView = this.sendPageView.bind(this);
    this.initialize = this.initialize.bind(this);

    this.initialize(props.id);
  }

  componentDidMount() {
    this.sendPageView(this.props.location);
    this.props.history.listen(this.sendPageView);
  }

  initialize() {
    if (!this.props.id) {
      console.error("[react-router-ga] Tracking ID is required.");
      return;
    }

    // Load Google Analytics
    (function(i, s, o, g, r, a, m) {
      i["GoogleAnalyticsObject"] = r;
      i[r] =
        i[r] ||
        function() {
          (i[r].q = i[r].q || []).push(arguments);
        };
      i[r].l = 1 * new Date();
      a = s.createElement(o);
      m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      "script",
      "https://www.google-analytics.com/analytics.js",
      "ga",
    );

    // Initialize Google Analytics
    window.ga("create", this.props.id, "auto");
    window.ga("set", "anonymizeIp", true);
    window.ga("send", "pageview");
  }

  sendPageView(location) {
    // Do nothing if GA was not initialized due to a missing tracking ID.
    if (!window.ga) {
      return;
    }

    // Do nothing if trackPathnameOnly is enabled and the pathname didn't change.
    if (
      this.props.trackPathnameOnly &&
      location.pathname === this.lastPathname
    ) {
      return;
    }

    this.lastPathname = location.pathname;

    // Sets the page value on the tracker. If a basename is provided, then it is prepended to the pathname.
    const page = this.props.basename
      ? `${this.props.basename}${location.pathname}`
      : location.pathname;

    window.ga("set", "page", page);

    // Sending the pageview no longer requires passing the page
    // value since it's now stored on the tracker object.
    window.ga("send", "pageview");

    if (this.props.debug) {
      console.info(`[react-router-ga] Page view: ${page}`);
    }
  }

  render() {
    return this.props.children;
  }
}

ReactRouterGA.defaultProps = {
  debug: false,
};

export default withRouter(ReactRouterGA);
